import * as React from "react";

import { DashboardPage } from "../../shared/components";
import { DashboardType } from "../../shared/types";
import { useDashboardContext } from "./_infra/dashboardProvider";
import { HiringTeamManagerDashboard } from "./hiringTeamManager";
import { HiringTeamMemberDashboard } from "./hiringTeamMember";

export const ClientDashboard = () => {
    const {
        state: {
            data: { dashboardType, lastSync },
        },
    } = useDashboardContext();

    return (
        <>
            <DashboardPage dashboardSyncDate={lastSync}>
                {dashboardType === DashboardType.HiringTeamManager && (
                    <HiringTeamManagerDashboard />
                )}
                {dashboardType === DashboardType.HiringTeamMember && (
                    <HiringTeamMemberDashboard />
                )}
            </DashboardPage>
        </>
    );
};
